<!--
  To recolor solid image use this generator
  https://angel-rs.github.io/css-color-filter-generator/
-->

<template>
  <div :class="{ failed: message.status === 'failed'}">
    <!-- List view -->
    <template v-if="!isArray">
      <div
        v-if="message.buttons.menu_title"
        class="button flex center-all"
        :class="{ 'show-hand': pointer }"
        @click="buttonAction(button)" >
        <img
          v-if="message.buttons.menu_icon"
          :src="message.status === 'failed' ? message.buttons.menu_icon.red : message.buttons.menu_icon.dark"
          class="menu-icon" >
        <p>{{ message.buttons.menu_title }}</p>
      </div>
      <template v-else>
        <div
          v-for="(button, index) in message.buttons.items"
          :key="index"
          class="button"
          :class="{ first: !index, 'show-hand': ['URL', 'PHONE_NUMBER'].includes(button.type), 'show-hand': pointer }"
          @click="buttonAction(button, index)" >
          <img
            v-if="button.icon"
            :src="message.status === 'failed' ? button.icon.red : button.icon.dark"
            class="menu-icon" >
          {{ button.title }}
          <button
            :ref="`button-${index}`"
            v-clipboard="button.value ? button.value : ''"
            class="hide"
            @success="copyToClipboard"
            @error="copyToClipboard(false)" />
        </div>
      </template>
    </template>

    <!-- Used on AI assistant test page -->
    <template v-else-if="!message.buttons.menu_title && message.buttons.items">
      <div
        v-for="(button, index) in message.buttons.items"
        :key="index"
        class="button"
        :class="{ first: !index, 'show-hand': button.value, 'show-hand': pointer }"
        @click="buttonAction(button)" >
        <img
          v-if="button.icon"
          :src="button.icon.dark"
          class="menu-icon" >
        {{ button.title }}
      </div>
    </template>

    <!-- Buttons view -->
    <template v-else>
      <div
        v-for="(button, index) in message.buttons"
        :key="index"
        class="button"
        :class="{ first: !index, 'show-hand': button.value, 'show-hand': pointer }"
        @click="buttonAction(button)" >
        <img
          v-if="button.icon"
          :src="button.icon.dark"
          class="menu-icon" >
        {{ button.title }}
      </div>
    </template>
  </div>
</template>

<script>
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import ToasterMixin from '@/mixins/Toaster';

export default {
  name: 'MessageButtons',
  components: {
    SBIcon,
  },
  mixins: [
    ToasterMixin,
  ],
  props: {
    message: {
      type: Object,
      required: true,
      default: () => {},
    },
    pointer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      SBColors,
      SBIconList,
    };
  },
  computed: {
    isList() {
      return this.message.buttons && this.message.buttons.menu_title;
    },
    isArray() {
      return Array.isArray(this.message.buttons);
    },
  },
  methods: {
    buttonAction(button, index) {
      if (button.type === 'URL') {
        window.open(button.value, '_blank');
      } else if (button.type === 'PHONE_NUMBER') {
        this.$refs[`button-${index}`][0].click();
      }

      this.$emit('button-click', button);
    },
    copyToClipboard(success = true) {
      if (success) {
        this.showToaster('Copied to clipboard.', null, null, 'OK');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  padding: 6px 18px;
  border-radius: 3px;
  border: 1px solid #b1cff2;
  background-color: $white;
  color: $bluePrimary;
  margin-top: 3px;
  font-size: 14px;
  font-weight: 400;
  text-align: center;

  .menu-icon {
    // filter: brightness(0) saturate(100%) invert(38%) sepia(35%) saturate(3318%) hue-rotate(198deg) brightness(98%) contrast(88%);
    height: 10px;
    margin-right: 4px;
  }

  &:last-of-type {
    border-radius: 3px 3px 18px 18px;
    margin-bottom: 2px;
  }
}

.failed .button {
  border: 1px solid $redPrimary;
  color: $redPrimary;

  .menu-icon {
    // filter: brightness(0) saturate(100%) invert(57%) sepia(97%) saturate(3658%) hue-rotate(326deg) brightness(110%) contrast(110%);
  }
}
</style>
